import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { TrafficLightStep } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class TrafficLightStepService extends TmsWebBaseEditService<TrafficLightStep, TrafficLightStep> {
  // Fired after the Details form saves: the screen stays open on save and the parent re-reads its model so
  // the summary refreshes in place.
  public refreshDetails = new Subject<void>();

  constructor() {
    super('TrafficLightStep', $localize`Traffic Light Step`);
  }
}
